import { render, staticRenderFns } from "./RatingClients.vue?vue&type=template&id=374c4ab5&"
import script from "./RatingClients.vue?vue&type=script&lang=js&"
export * from "./RatingClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports